































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component} from 'vue-property-decorator'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'
import {OrbitProject} from '@/model/resource/OrbitProject'
import {Contract} from '@/model/resource/Contract'
import {
  OrbitHelper,
  ORBIT_DEFAULT_CONFIG_MS,
  formatOrbitPhaseDurationMs,
} from '@/helpers/OrbitHelper'
import OrbitAddProjectModal from '@/components/orbit/OrbitAddProjectModal.vue'
import OrbitFundProjectModal from '@/components/orbit/OrbitFundProjectModal.vue'
import OrbitPauseModal from '@/components/orbit/OrbitPauseModal.vue'
import OrbitUnpauseModal from '@/components/orbit/OrbitUnpauseModal.vue'
import OrbitStartRoundModal from '@/components/orbit/OrbitStartRoundModal.vue'
import OrbitEndRoundModal from '@/components/orbit/OrbitEndRoundModal.vue'
import OrbitSetupModal from '@/components/orbit/OrbitSetupModal.vue'
import {DateHelper} from '@/helpers/DateHelper'
import {InputCheckbox, InputSelect} from '@simpli/vue-input'
import {
  OrbitNetworkHelper,
  OrbitNetworkOption,
} from '@/helpers/OrbitNetworkHelper'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import ConnectWalletModal from '@/components/walletConnection/ConnectWalletModal.vue'
import OrbitRemoveProjectModal from '@/components/orbit/OrbitRemoveProjectModal.vue'
import OrbitEditProjectModal from '@/components/orbit/OrbitEditProjectModal.vue'
import OrbitForceEndRoundModal from '@/components/orbit/OrbitForceEndRoundModal.vue'
import OrbitRefundContractModal from '@/components/orbit/OrbitRefundContractModal.vue'
import ToggleButtonOrbit from '@/components/misc/ToggleButtonOrbit.vue'
import {$} from '@/facade'
import {ContractCollection} from '@/model/collection/ContractCollection'
import {OrbitRoundCollection} from '@/model/collection/OrbitRoundCollection'
import {currentN3Network} from '@/helpers/NetworkModeRegistry'
import {OrbitRound} from '@/model/resource/OrbitRound'
import {NetworkNamespace} from '@/enums/NetworkNamespace'

@Component({
  computed: {
    DateHelper() {
      return DateHelper
    },
  },
  components: {
    OrbitForceEndRoundModal,
    OrbitRefundContractModal,
    OrbitEditProjectModal,
    OrbitRemoveProjectModal,
    ConnectWalletModal,
    OrbitAddProjectModal,
    OrbitFundProjectModal,
    OrbitPauseModal,
    OrbitUnpauseModal,
    OrbitStartRoundModal,
    OrbitEndRoundModal,
    OrbitSetupModal,
    ToggleButtonOrbit,
    InputCheckbox,
    InputSelect,
  },
})
export default class ListOrbitView extends MixinScreenSize {
  collection = new OrbitProjectCollection()
  showSetupOrbitModal = false
  showPauseOrbitModal = false
  showUnpauseOrbitModal = false

  showStartRoundModal = false
  showEndRoundModal = false
  showForceEndRoundModal = false

  showAddProjectModal = false
  showFundProjectModal = false
  showEditProjectModal = false
  showRemoveProjectModal = false
  showRefundContractModal = false

  selectedOrbitProjects: OrbitProject[] = []
  selectedOrbitProject: OrbitProject | null = null

  isOrbitPaused = false
  isRoundActive = false
  roundEndTime: number | null = null
  orbitPhaseMs = {
    round: ORBIT_DEFAULT_CONFIG_MS.roundDuration,
    claim: ORBIT_DEFAULT_CONFIG_MS.claimDuration,
    distribution: ORBIT_DEFAULT_CONFIG_MS.distributionDuration,
    lockout: ORBIT_DEFAULT_CONFIG_MS.lockoutDuration,
  }
  activeRound: string | null = null
  activeRoundByNetwork: Record<string, number | null> = {}
  canEndRound = false
  roundToEnd: number | null = null

  isSyncing = false

  networkFilter: string | null = null

  get networkFilterOptions(): OrbitNetworkOption[] {
    return OrbitNetworkHelper.options(this.$translate('view.orbitNetwork.all'))
  }

  get networkFilterSelectValue(): OrbitNetworkOption | null {
    return OrbitNetworkHelper.optionOf(
      this.networkFilterOptions,
      this.networkFilter
    )
  }

  set networkFilterSelectValue(option: OrbitNetworkOption | null) {
    const next = !option || option.$id === '' ? null : option.$id
    if (next === this.networkFilter) return

    this.networkFilter = next
    this.selectedOrbitProjects = []
    // Not applyCollection(): that would also reset the round toggle the admin set.
    this.collection.networkIdentifier = next
    this.populateResources()
  }

  get signingNetwork(): string {
    return currentN3Network()
  }

  get signingNetworkLabel(): string {
    return OrbitNetworkHelper.label(this.signingNetwork)
  }

  isOnSigningNetwork(item: OrbitProject): boolean {
    return (
      item.blockchainVersion?.networkIdentifier?.trim().toLowerCase() ===
      this.signingNetwork
    )
  }

  networkLabel(item: OrbitProject): string {
    return OrbitNetworkHelper.label(item.blockchainVersion?.networkIdentifier)
  }

  lockedRowTooltip(item: OrbitProject): string {
    return this.$translate('view.orbitNetwork.lockedRow', {
      network: this.networkLabel(item),
      signing: this.signingNetworkLabel,
    })
  }

  networkBadgeClass(item: OrbitProject): string {
    return OrbitNetworkHelper.badgeClass(
      item.blockchainVersion?.networkIdentifier
    )
  }

  mounted() {
    this.applyCollection()
    this.populateResources()
  }

  applyCollection() {
    this.collection.active = true
    this.collection.networkIdentifier = this.networkFilter
    this.collection.onlyRunningOrNullRound = true
    this.collection.orderBy = 'round'
    this.collection.asc = false
    this.collection.limit = 10
    this.collection.perPage = 10
  }

  async populateResources() {
    const promises: Array<Promise<unknown>> = [
      this.collection.queryAsPage(),
      this.setIsPaused(),
      this.setIsRoundActive(),
      this.setRoundEndTime(),
      this.setOrbitPhaseDays(),
      this.setActiveRound(),
      this.setCanEndRound(),
    ]

    await this.$await.run('softQuery', () => Promise.all(promises))
    this.normalizeCollectionItems()
  }

  truncateAddress(address: string) {
    return address?.trim()
      ? `${address.trim().slice(0, 5)}...${address.trim().slice(-5)}`
      : null
  }

  /**
   * Pulls the Orbit contract of BOTH N3 networks into the DB — the admin filters by
   * the Network column afterwards. Each network is independent: its own
   * blockchain_version row, its own rounds (round numbers restart per network) and
   * its own soft-delete pass. One network being unreachable must not cost the other
   * one its sync, nor soft-delete its projects.
   */
  async syncWithOrbitContract() {
    try {
      this.isSyncing = true

      let syncedProjectCount = 0
      let softDeletedCount = 0
      let skippedProjectCount = 0
      const emptyNetworks: string[] = []
      const failedNetworks: string[] = []

      for (const network of OrbitNetworkHelper.identifiers) {
        try {
          const result = await this.syncOrbitContractNetwork(network)

          if (result.empty) {
            emptyNetworks.push(network)
            continue
          }

          syncedProjectCount += result.synced
          softDeletedCount += result.softDeleted
          skippedProjectCount += result.skipped
        } catch (err) {
          console.error(`Orbit sync failed for ${network}:`, err)
          failedNetworks.push(network)
        }
      }

      if (failedNetworks.length) {
        $.toast.error(
          $.translate('view.ListOrbitView.syncOrbitNetworkFailed', {
            networks: failedNetworks
              .map(net => OrbitNetworkHelper.label(net))
              .join(', '),
          }),
          '',
          false
        )
      }

      if (emptyNetworks.length) {
        $.toast.info(
          $.translate('view.ListOrbitView.syncOrbitNetworkEmpty', {
            networks: emptyNetworks
              .map(net => OrbitNetworkHelper.label(net))
              .join(', '),
          }),
          '',
          false
        )
      }

      if (skippedProjectCount > 0) {
        $.toast.info(
          $.translate('view.ListOrbitView.syncOrbitSkippedProjects', {
            count: skippedProjectCount,
          }),
          '',
          false
        )
      }

      if (
        emptyNetworks.length + failedNetworks.length ===
        OrbitNetworkHelper.identifiers.length
      ) {
        $.toast.error('view.ListOrbitView.syncOrbitNoProjects', '', true)
        return
      }

      $.toast.success(
        $.translate('view.ListOrbitView.syncOrbitSoftDeleted', {
          count: softDeletedCount,
        }),
        '',
        false
      )

      $.toast.success(
        $.translate('view.ListOrbitView.syncOrbitProjectsSuccess', {
          count: syncedProjectCount,
        }),
        '',
        false
      )

      await this.populateResources()
    } catch (err) {
      $.toast.error('view.ListOrbitView.syncOrbitError', '', true)
      console.error(err)
    } finally {
      this.isSyncing = false
    }
  }

  /**
   * Syncs one network's Orbit contract. Everything it reads and writes is scoped to
   * `network`, so it never sees — let alone soft-deletes — the other network's rows.
   */
  private async syncOrbitContractNetwork(
    network: string
  ): Promise<{
    empty: boolean
    synced: number
    softDeleted: number
    skipped: number
  }> {
    const [roundsFromContract, projectsFromContract] = await Promise.all([
      OrbitHelper.getAllRounds(network),
      OrbitHelper.getAllProjects(network),
    ])

    // No projects means nothing to mirror. Bail out BEFORE the soft-delete pass: an
    // empty (or misbehaving) contract read must not wipe the network's projects.
    if (!Array.isArray(projectsFromContract) || !projectsFromContract.length) {
      return {empty: true, synced: 0, softDeleted: 0, skipped: 0}
    }

    const blockchainVersion = await OrbitNetworkHelper.blockchainVersionOf(
      network
    )

    // contract.hash is UNIQUE across the whole table, so one hash is already one
    // network — filtering these by network would only risk dropping rows whose
    // idBlockchainVersionFk was never filled in.
    const projectHashes = Array.from(
      new Set(projectsFromContract.map(op => op.project))
    )

    const contractCollection = new ContractCollection()
    contractCollection.hashes = projectHashes
    contractCollection.limit = projectHashes.length
    contractCollection.active = null
    await contractCollection.queryAsPage()

    const paymentTokenHashes = Array.from(
      new Set(projectsFromContract.map(op => op.token))
    )

    const tokenMap = await OrbitNetworkHelper.paymentTokenMapOf(
      network,
      paymentTokenHashes
    )

    const contractMap = new Map(
      (contractCollection.items || [])
        .filter((c): c is Contract & {hash: string} => !!c.hash)
        .map(c => [c.hash, c])
    )

    const orbitRoundCollection = new OrbitRoundCollection()
    orbitRoundCollection.limit = 999
    orbitRoundCollection.networkIdentifier = network
    await orbitRoundCollection.queryAsPage()

    const orbitProjectCollection = new OrbitProjectCollection()
    orbitProjectCollection.limit = 999
    orbitProjectCollection.networkIdentifier = network
    await orbitProjectCollection.queryAsPage()

    const existingOrbitProjectMap = new Map(
      (orbitProjectCollection.items || []).map(p => [
        `${p.contract?.hash}_${p.instanceId}`,
        p,
      ])
    )

    let orbitRoundMap = new Map(
      (orbitRoundCollection.items || []).map(or => [or.round, or])
    )

    const activeRoundNumber = Number(await OrbitHelper.getActiveRound(network))
    const activeRoundEndMs = await OrbitHelper.getRoundEndTimeMs(network)

    const toPositiveMs = (raw: number) => {
      const n = OrbitHelper.normalizeContractTimeMs(raw)
      return n > 0 ? n : 0
    }

    const orbitCfgFromRow = (row: typeof roundsFromContract[0]) => ({
      roundDuration:
        row.roundDuration > 0
          ? row.roundDuration
          : ORBIT_DEFAULT_CONFIG_MS.roundDuration,
      claimDuration:
        row.claimDuration > 0
          ? row.claimDuration
          : ORBIT_DEFAULT_CONFIG_MS.claimDuration,
      distributionDuration:
        row.distributionDuration > 0
          ? row.distributionDuration
          : ORBIT_DEFAULT_CONFIG_MS.distributionDuration,
      lockoutDuration:
        row.lockoutDuration > 0
          ? row.lockoutDuration
          : ORBIT_DEFAULT_CONFIG_MS.lockoutDuration,
    })

    const resolveRoundPhaseMs = (
      row: typeof roundsFromContract[0],
      isRoundActive: boolean
    ) => {
      let nEnd = toPositiveMs(row.endTime)
      if (nEnd <= 0 && isRoundActive && activeRoundEndMs > 0) {
        nEnd = activeRoundEndMs
      }

      let claimMs = toPositiveMs(row.claimEndTime)
      let distMs = toPositiveMs(row.distributionEndTime)
      let finMs = toPositiveMs(row.finishedTime)

      if (nEnd > 0) {
        if (claimMs <= 0 || distMs <= 0 || finMs <= 0) {
          const p = OrbitHelper.phaseEndTimesFromActiveEndMs(
            nEnd,
            orbitCfgFromRow(row)
          )
          if (claimMs <= 0) claimMs = p.claimEndMs
          if (distMs <= 0) distMs = p.distributionEndMs
          if (finMs <= 0) finMs = p.finishedMs
        }
      }

      return {
        endMs: nEnd > 0 ? nEnd : null,
        claimMs: claimMs > 0 ? claimMs : null,
        distMs: distMs > 0 ? distMs : null,
        finMs: finMs > 0 ? finMs : null,
      }
    }

    for (const row of roundsFromContract) {
      const roundNumber = row.roundNumber
      const isRoundActive = roundNumber === activeRoundNumber
      const isRunning = isRoundActive && !row.finished
      const phase = resolveRoundPhaseMs(row, isRoundActive)
      const startMs = toPositiveMs(row.startTime)

      const existingRound = orbitRoundMap.get(roundNumber)
      const orbitRound = existingRound || new OrbitRound()

      orbitRound.blockchainVersion = blockchainVersion
      orbitRound.isRunning = isRunning

      if (!existingRound) {
        orbitRound.round = roundNumber
        orbitRound.transactionHash = null
        orbitRound.createdAt = DateHelper.formatDateForBackend(
          Date.now()
        ) as any
      }

      if (!existingRound || startMs > 0) {
        orbitRound.startsAt = DateHelper.formatDateForBackend(
          startMs > 0 ? startMs : null
        ) as any
      }

      orbitRound.endsAt = DateHelper.formatDateForBackend(phase.endMs) as any
      orbitRound.claimEndsAt = DateHelper.formatDateForBackend(
        phase.claimMs
      ) as any
      orbitRound.distributionEndsAt = DateHelper.formatDateForBackend(
        phase.distMs
      ) as any
      orbitRound.finishedAt = DateHelper.formatDateForBackend(
        phase.finMs
      ) as any

      await orbitRound.persistOrbitRound()
    }

    await orbitRoundCollection.queryAsPage()
    orbitRoundMap = new Map(
      (orbitRoundCollection.items || []).map(or => [or.round, or])
    )

    const activeKeys = new Set<string>()
    let synced = 0
    let skipped = 0
    let softDeleted = 0

    for (const op of projectsFromContract) {
      const key = `${op.project}_${op.instanceId}`
      activeKeys.add(key)

      const existing = existingOrbitProjectMap.get(key)
      const contract = contractMap.get(op.project) || null
      const tokenPriced = tokenMap.get(op.token.trim().toLowerCase()) || null

      // Both FKs are NOT NULL in the DB: a contract or payment token that was never
      // registered on this network would blow up the whole sync mid-way.
      if (!contract || !tokenPriced) {
        console.warn(
          `Skipping Orbit project ${key} on ${network}: ${
            !contract ? 'contract' : 'payment token'
          } is not registered`
        )
        skipped++
        continue
      }

      const orbitProject = existing || new OrbitProject()

      orbitProject.idOrbitProjectPk = orbitProject.idOrbitProjectPk ?? null
      orbitProject.blockchainVersion = blockchainVersion
      orbitProject.contract = contract
      orbitProject.tokenPriced = tokenPriced
      orbitProject.creatorAddress = orbitProject.creatorAddress || null
      orbitProject.amount = Number(op.amount)
      orbitProject.assetType =
        op.assetType != null ? String(op.assetType) : null
      orbitProject.isFunded = op.funded ?? false
      orbitProject.transactionHash = null
      orbitProject.instanceId = orbitProject.instanceId ?? Number(op.instanceId)
      orbitProject.eventNames = op.eventName

      const contractRound = Number(op.round)
      const hasOrbitRound = Number.isFinite(contractRound) && contractRound > 0
      orbitProject.orbitRound = hasOrbitRound
        ? orbitRoundMap.get(contractRound) ?? null
        : null

      orbitProject.active = true

      if (!existing) {
        orbitProject.createdAt = DateHelper.formatDateForBackend(
          Date.now()
        ) as any
      }

      await orbitProject.persistOrbitProject()
      synced++
    }

    for (const project of orbitProjectCollection.items) {
      const key = `${project.contract?.hash}_${project.instanceId}`

      if (!activeKeys.has(key) && project.active) {
        project.active = false
        await project.persistOrbitProject()
        softDeleted++
      }
    }

    return {empty: false, synced, softDeleted, skipped}
  }

  selectOrbitProject(item: OrbitProject) {
    if (!Array.isArray(this.selectedOrbitProjects)) {
      this.selectedOrbitProjects = []
    }

    if (!this.isOnSigningNetwork(item)) {
      $.toast.error(this.lockedRowTooltip(item), '', false)
      return
    }

    const index = this.selectedOrbitProjects.findIndex(
      orbitProject => orbitProject.idOrbitProjectPk === item.idOrbitProjectPk
    )

    if (index !== -1) {
      this.selectedOrbitProjects.splice(index, 1)
    } else {
      this.selectedOrbitProjects.push(item)
    }
  }

  async setIsPaused() {
    this.isOrbitPaused = await OrbitHelper.isPaused()
  }

  async setIsRoundActive() {
    this.isRoundActive = await OrbitHelper.isRoundActive()
  }

  async setRoundEndTime() {
    const endMs = await OrbitHelper.getRoundEndTimeMs()

    if (!endMs || Number.isNaN(endMs) || endMs <= 0) {
      this.roundEndTime = null
      return
    }

    this.roundEndTime = endMs
  }

  formatAmount(amount: number | string, decimals: number): string {
    const divisor = 10 ** decimals
    const value = Number(amount) / divisor

    let formatted = value.toFixed(decimals)

    formatted = formatted.replace(/\.?0+$/, '')

    return formatted
  }

  formattedAmount(orbitProject: OrbitProject) {
    const amount = this.formatAmount(
      Number(orbitProject.amount),
      orbitProject.tokenPriced?.decimals ?? 0
    )

    return `${amount} ${orbitProject.tokenPriced?.symbol}`
  }

  isOrbitRoundDateMissing(
    project: OrbitProject,
    key:
      | 'startsAt'
      | 'endsAt'
      | 'claimEndsAt'
      | 'distributionEndsAt'
      | 'finishedAt'
  ): boolean {
    const or = project.orbitRound
    if (!or || or.round == null) return true
    const ts = or[key]
    return ts == null || ts === ('' as any)
  }

  orbitRoundDateDisplay(
    project: OrbitProject,
    key:
      | 'startsAt'
      | 'endsAt'
      | 'claimEndsAt'
      | 'distributionEndsAt'
      | 'finishedAt'
  ): string {
    if (this.isOrbitRoundDateMissing(project, key)) return '—'
    const or = project.orbitRound!
    const ts = or[key] as Date | string | number
    const forFmt = ts instanceof Date ? ts.getTime() : ts
    return DateHelper.formatDatetime(forFmt) || '—'
  }

  orbitRoundPhaseLines(
    project: OrbitProject
  ): Array<{
    key: string
    label: string
    value: string
    muted: boolean
  }> {
    type PhaseField =
      | 'startsAt'
      | 'endsAt'
      | 'claimEndsAt'
      | 'distributionEndsAt'
      | 'finishedAt'

    const rows: Array<{key: string; langKey: string; field: PhaseField}> = [
      {
        key: 'starts',
        langKey: 'view.ListOrbitView.phaseLineStartsAt',
        field: 'startsAt',
      },
      {
        key: 'ends',
        langKey: 'view.ListOrbitView.phaseLineEndsAt',
        field: 'endsAt',
      },
      {
        key: 'claim',
        langKey: 'view.ListOrbitView.phaseLineClaimEndsAt',
        field: 'claimEndsAt',
      },
      {
        key: 'dist',
        langKey: 'view.ListOrbitView.phaseLineDistributionEndsAt',
        field: 'distributionEndsAt',
      },
      {
        key: 'fin',
        langKey: 'view.ListOrbitView.phaseLineFinishesAt',
        field: 'finishedAt',
      },
    ]

    return rows.map(r => ({
      key: r.key,
      label: $.translate(r.langKey),
      value: this.orbitRoundDateDisplay(project, r.field),
      muted: this.isOrbitRoundDateMissing(project, r.field),
    }))
  }

  getRoundStatusBadgeClass(orbitRound: OrbitRound): string {
    if (!orbitRound) return ''

    if (orbitRound.isRunning) {
      return 'bg-blue-100 text-blue-800'
    }

    if (!orbitRound.isRunning && orbitRound.endsAt) {
      const endsAtDate =
        typeof orbitRound.endsAt === 'string'
          ? new Date(orbitRound.endsAt)
          : new Date(orbitRound.endsAt)
      const now = new Date()

      if (endsAtDate < now) {
        return 'bg-green-100 text-green-800'
      }
    }

    return 'bg-yellow-100 text-yellow-800'
  }

  getRoundStatusText(orbitRound: OrbitRound): string {
    if (!orbitRound) return ''

    if (orbitRound.isRunning) {
      return 'Active'
    }

    if (!orbitRound.isRunning && orbitRound.endsAt) {
      const endsAtDate =
        typeof orbitRound.endsAt === 'string'
          ? new Date(orbitRound.endsAt)
          : new Date(orbitRound.endsAt)
      const now = new Date()

      if (endsAtDate < now) {
        return 'Completed'
      }
    }

    return 'Pending'
  }

  getProjectStatusBadgeClass(orbitProject: OrbitProject): string {
    if (!orbitProject) return ''

    const hasRound = orbitProject.orbitRound && orbitProject.orbitRound.round
    const roundNumber = hasRound ? orbitProject.orbitRound?.round : null
    const activeRoundNumber = this.activeRoundOf(orbitProject)
    const isRoundActive =
      hasRound &&
      roundNumber !== null &&
      activeRoundNumber !== null &&
      roundNumber === activeRoundNumber
    const isFunded = orbitProject.isFunded === true

    if (hasRound && isRoundActive) {
      return 'bg-blue-100 text-blue-800'
    }

    if (hasRound && !isRoundActive) {
      return 'bg-green-100 text-green-800'
    }

    if (!hasRound && isFunded) {
      return 'bg-indigo-100 text-indigo-800'
    }

    if (!hasRound && !isFunded) {
      return 'bg-yellow-100 text-yellow-800'
    }

    return 'bg-gray-100 text-gray-800'
  }

  getProjectStatusText(orbitProject: OrbitProject): string {
    if (!orbitProject) return ''

    const hasRound = orbitProject.orbitRound && orbitProject.orbitRound.round
    const roundNumber = hasRound ? orbitProject.orbitRound?.round : null
    const activeRoundNumber = this.activeRoundOf(orbitProject)
    const isRoundActive =
      hasRound &&
      roundNumber !== null &&
      activeRoundNumber !== null &&
      roundNumber === activeRoundNumber
    const isFunded = orbitProject.isFunded === true

    if (hasRound && isRoundActive) {
      return 'In Progress'
    }

    if (hasRound && !isRoundActive) {
      return 'Finished'
    }

    if (!hasRound && isFunded) {
      return 'Ready to Start'
    }

    if (!hasRound && !isFunded) {
      return 'Awaiting Fund'
    }

    return 'Unknown'
  }

  async setOrbitPhaseDays() {
    const cfg = await OrbitHelper.resolveOrbitConfig()
    this.orbitPhaseMs = {
      round: cfg.roundDuration,
      claim: cfg.claimDuration,
      distribution: cfg.distributionDuration,
      lockout: cfg.lockoutDuration,
    }
  }

  phaseLengthLabel(phase: 'round' | 'claim' | 'distribution' | 'lockout') {
    return formatOrbitPhaseDurationMs(this.orbitPhaseMs[phase], (key, values) =>
      this.$translate(key, values)
    )
  }

  async setActiveRound() {
    const byNetwork: Record<string, number | null> = {}

    await Promise.all(
      OrbitNetworkHelper.identifiers.map(async network => {
        try {
          const round = Number(await OrbitHelper.getActiveRound(network))
          byNetwork[network] =
            Number.isFinite(round) && round > 0 ? round : null
        } catch (err) {
          console.error(`Could not read the active round of ${network}:`, err)
          byNetwork[network] = null
        }
      })
    )

    this.activeRoundByNetwork = byNetwork

    const signingRound = byNetwork[this.signingNetwork]
    this.activeRound = signingRound == null ? null : String(signingRound)
  }

  private activeRoundOf(orbitProject: OrbitProject): number | null {
    const network = orbitProject.blockchainVersion?.networkIdentifier
      ?.trim()
      .toLowerCase()

    if (!network) return null

    return this.activeRoundByNetwork[network] ?? null
  }

  async setCanEndRound() {
    try {
      const orbitRoundCollection = new OrbitRoundCollection()
      orbitRoundCollection.limit = 999
      // The end-round button signs on the bar's network.
      orbitRoundCollection.networkIdentifier = currentN3Network()
      await orbitRoundCollection.queryAsPage()

      if (
        !orbitRoundCollection.items ||
        orbitRoundCollection.items.length === 0
      ) {
        this.canEndRound = false
        return
      }

      const rounds = orbitRoundCollection.items.filter(
        r => r.round !== null && r.round !== undefined
      )

      if (rounds.length === 0) {
        this.canEndRound = false
        return
      }

      const sortedRounds = rounds.sort((a, b) => {
        const roundA = a.round || 0
        const roundB = b.round || 0
        return roundB - roundA
      })

      const lastRoundFromDB = sortedRounds[0]
      const lastRoundNumberFromDB = lastRoundFromDB.round!

      const activeRoundFromContract = await OrbitHelper.getActiveRound()
      const activeRoundNumber = Number(activeRoundFromContract) || 0
      const isLastRoundActiveInContract =
        activeRoundNumber === lastRoundNumberFromDB

      const lastRoundFromContract = await OrbitHelper.getLastRound()
      const lastRoundNumberFromContract = Number(lastRoundFromContract) || 0

      if (isLastRoundActiveInContract) {
        this.canEndRound = true
        this.roundToEnd = null
        return
      }

      const shouldAllowEndRound =
        lastRoundNumberFromDB > lastRoundNumberFromContract &&
        !!lastRoundFromDB.isRunning

      this.canEndRound = shouldAllowEndRound

      if (shouldAllowEndRound && !isLastRoundActiveInContract) {
        this.roundToEnd = lastRoundNumberFromDB
      } else {
        this.roundToEnd = null
      }
    } catch (error) {
      console.error('Error checking canEndRound:', error)
      this.canEndRound = false
    }
  }

  copyToClipboard(val: string) {
    this.$utils.copyToClipboard(val)
    this.$toast.info('system.info.copiedToClipboard')
  }

  openAddProjectModal() {
    this.showAddProjectModal = true
  }

  async handleCloseAddProjectModal() {
    this.selectedOrbitProjects = []
    this.showAddProjectModal = false
    await this.populateResources()
  }

  openSetupOrbitModal() {
    this.showSetupOrbitModal = true
  }

  async handleCloseSetupOrbitModal() {
    this.selectedOrbitProjects = []
    this.showSetupOrbitModal = false
    await this.populateResources()
  }

  openStartRoundModal() {
    this.selectedOrbitProjects = this.selectedOrbitProjects.map(item =>
      Object.assign(new OrbitProject(), item)
    )
    this.showStartRoundModal = true
  }

  async handleCloseStartRoundModal() {
    this.selectedOrbitProjects = []
    this.showStartRoundModal = false
    await this.populateResources()
  }

  openForceEndRoundModal() {
    this.showForceEndRoundModal = true
  }

  async handleCloseForceEndRoundModal() {
    this.selectedOrbitProjects = []
    this.showForceEndRoundModal = false
    await this.populateResources()
  }

  openEndRoundModal() {
    this.showEndRoundModal = true
  }

  async handleCloseEndRoundModal() {
    this.selectedOrbitProjects = []
    this.showEndRoundModal = false
    await this.populateResources()
  }

  openPauseOrbitModal() {
    this.showPauseOrbitModal = true
  }

  async handleClosePauseOrbitModal() {
    this.selectedOrbitProjects = []
    this.showPauseOrbitModal = false
    await this.populateResources()
  }

  openUnpauseOrbitModal() {
    this.showUnpauseOrbitModal = true
  }

  async handleCloseUnpauseOrbitModal() {
    this.showUnpauseOrbitModal = false
    await this.populateResources()
  }

  openFundProjectModal() {
    this.showFundProjectModal = true
    this.selectedOrbitProjects = this.selectedOrbitProjects.map(item =>
      Object.assign(new OrbitProject(), item)
    )
  }

  async handleCloseFundProjectModal() {
    this.selectedOrbitProjects = []
    this.showFundProjectModal = false
    await this.populateResources()
  }

  openRemoveProjectModal(item: OrbitProject) {
    this.showRemoveProjectModal = true
    this.selectedOrbitProject = item
  }

  async handleCloseRemoveProjectModal() {
    this.selectedOrbitProject = null
    this.selectedOrbitProjects = []
    this.showRemoveProjectModal = false
    await this.populateResources()
  }

  openEditProjectModal(item: OrbitProject) {
    this.showEditProjectModal = true
    this.selectedOrbitProject = item
  }

  async handleCloseEditProjectModal() {
    this.selectedOrbitProject = null
    this.selectedOrbitProjects = []
    this.showEditProjectModal = false
    await this.populateResources()
  }

  connectN3Address() {
    $.modal.open('connectWalletModal', {
      networkNamespace: NetworkNamespace.n3,
    })
  }

  async disconnectN3Address() {
    $.walletAdapter.disconnectN3Wallet()
  }

  private toMs(ts: unknown): number | null {
    const n = Number(ts)
    if (!Number.isFinite(n) || n <= 0) return null
    return n < 1e12 ? n * 1000 : n
  }

  private normalizeCollectionItems() {
    this.collection.items = this.collection.items.map((i: any) => {
      const deadlineMs = this.toMs(i.deadlineAt)
      const createdMs = this.toMs(i.createdAt)
      return {
        ...i,
        deadlineAt: deadlineMs,
        createdAt: createdMs ?? i.createdAt,
      }
    })
  }

  async handleToggleChange() {
    await this.populateResources()
  }

  async openRefundContractModal() {
    try {
      await OrbitHelper.checkWalletPermissions()
      this.showRefundContractModal = true
    } catch {
      /* checkWalletPermissions opens connect modal / disconnects; toast.abort rejects */
    }
  }

  async handleCloseRefundContractModal() {
    this.showRefundContractModal = false
    await this.populateResources()
  }
}
